<template>
  <v-row dense>
    <v-col cols="12">
      <v-card class="card-border" :disabled="loading">
        <v-card-text>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :search="table.search"
            :single-expand="false"
            :expanded.sync="table.expanded"
            item-key="nome"
            show-expand
            :loading="loading"
            :loading-text="'Carregando...'"
          >
            <template v-slot:top>
              <v-row dense>
                <v-col cols="12" sm="12">
                  <v-btn fab x-small depressed @click="getMenus()"><v-icon>mdi-refresh</v-icon></v-btn>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field v-model="table.search" label="Procurar..." prepend-inner-icon="mdi-magnify" />
                </v-col>
              </v-row>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <tr v-for="acesso in item.acessos" :key="item.nome+acesso.nome">{{ acesso.nome }}</tr>
              </td>
            </template>

            <template v-slot:[`item.children`]="{ item }">
              <v-icon color="green" v-if="item.children">mdi-check</v-icon>
              <v-icon color="red" v-else>mdi-close</v-icon>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                v-if="$ability.can('Editar','Menus')"
                title="Editar Nome"
                color="transparent"
                small
                fab
                depressed
                @click="$refs.DialogEditarUsuario.show({ ...item })"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
              <v-btn
                v-if="$ability.can('Acessos','Menus')"
                title="Editar Acessos"
                color="transparent"
                small
                fab
                depressed
                @click="$refs.DialogEditarUsuario.show({ ...item })"
              >
                <v-icon>mdi-shield-edit</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Menus from '@/services/menus'

export default {
  name: 'Menus',

  data() {
    return {
      loading: false,

      table: {
        search: '',
        expanded: [],
        headers: [
          {
            text: 'Nome',
            value: 'nome'
          },
          {
            text: 'Tem Submenus?',
            value: 'children'
          },
          {
            text: '',
            value: 'actions'
          }
        ],
        data: []
      }
    }
  },

  methods: {
    async getMenus() {
      try
      {
        this.loading = true
        this.table.data = await new Menus().list()
      }
      catch(error)
      {
        console.error(error)
        this.$swal.error(error)
      }
      finally
      {
        this.loading = false
      }
    }
  },

  mounted() {
    this.getMenus()
  }
}
</script>
